import React, { useEffect } from 'react';
import Layout from './pages/layout/Layout';
import './App.css';
import { checkAuthenticated } from './redux/slices/loginSlice';
import { useDispatch } from 'react-redux';

function App() {
  const dispatch = useDispatch();

    dispatch(checkAuthenticated());


  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
